import { useAuth } from '../contexts/AuthContext';
import { hasAnyPermission, hasAllPermissions, hasPermission as hasPermissionUtil } from './permissions';

export function usePermissions() {
  const { permissions } = useAuth();
  return {
    permissions,
    hasPermission: (code: string) => hasPermissionUtil(permissions, code),
    hasAny: (codes: string[]) => hasAnyPermission(permissions, codes),
    hasAll: (codes: string[]) => hasAllPermissions(permissions, codes),
  };
}

